<template>
  <ul role="menubar" class="pagination my-0 b-pagination pagination-md text-center">
    <li :class="{ disabled: !dataSet.prev_page_url }" class="page-item flex-fill d-flex">
      <button class="page-link flex-grow-1" @click="pageChanged(dataSet.current_page - 1)">
        <i class="ri-arrow-left-s-line"></i>
      </button>
    </li>
    <li v-if="dataSet.current_page - 4 > 1" class="page-item flex-fill d-flex">...</li>
    <li
      v-for="page in range(dataSet.current_page, dataSet.last_page)"
      :key="page"
      class="page-item"
      :class="{ active: page === dataSet.current_page }"
    >
      <button class="page-link flex-grow-1" @click="pageChanged(page)">{{ page }}</button>
    </li>
    <li v-if="dataSet.current_page + 3 < dataSet.last_page" class="page-item flex-fill d-flex">...</li>
    <li :class="{ disabled: !dataSet.next_page_url }" class="page-item flex-fill d-flex">
      <button class="page-link flex-grow-1" @click="pageChanged(dataSet.current_page + 1)">
        <i class="ri-arrow-right-s-line"></i>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["dataSet"],

  data() {
    return {
      data: []
    };
  },
  watch: {},
  computed: {},
  mounted () {
  },
  methods: {
    pageChanged(page) {
      this.$emit("goToPage", page);
      /*this.$store.commit("setBackData", {
        page: page,
        routeName: this.$route.name,
      });*/
    },
    range(page, last_page) {
      let array = [],
        j = 0;
      for (let i = page - 4; i <= page + 4; i++) {
        if (i >= 1 && i <= last_page) {
          array[j] = i;
          j++;
        }
      }
      return array;
    }
  }
};
</script>
